import { useQuery } from "@tanstack/react-query";
import { authApi } from "../api/endpoints";

export function useSession() {
  return useQuery({
    queryKey: ["session"],
    queryFn: async () => (await authApi.me()).user,
    retry: false,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchInterval: 60_000,
  });
}
